import { useEffect, useState, useCallback } from 'react';
import { getCode, setCode, clearCode, listNiches, genNiches, updateNiche, removeNiche, lockMessage } from '../api/lionjob';

// NGÁCH — gom cụm từ khoá đang lên thành đề bài cụ thể để làm thiết kế.
// Vì sao cần: trước đây khâu viết SEO chỉ có mỗi productTitle nên title/tag hay chung chung.
// Có ngách kèm "ai mua / dịp gì / từ khoá thật" thì Claude viết bám người tìm hơn hẳn.
const N = (v, d = 1) => (v == null ? '—' : new Intl.NumberFormat('vi-VN', { maximumFractionDigits: d }).format(v));
const COMP = { low: { t: 'Ít cạnh tranh', c: 'ok' }, medium: { t: 'Cạnh tranh vừa', c: 'mid' }, high: { t: 'Đông người bán', c: 'hot' } };
const STATUS = [
  { key: 'all', label: 'Tất cả' },
  { key: 'new', label: 'Chưa dùng' },
  { key: 'used', label: 'Đã dùng' },
  { key: 'skipped', label: 'Bỏ qua' },
];

export default function NichePage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [data, setData] = useState(null);
  const [status, setStatus] = useState('new');
  const [day, setDay] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(null);

  const load = useCallback(async (st, dy) => {
    try {
      setData(await listNiches({ status: st, day: dy || undefined, limit: 60 }));
      setUnlocked(true);
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); return; }
      setLockErr(lockMessage(e)); setMsg('Lỗi: ' + m);
    }
  }, []);
  useEffect(() => { if (getCode()) load(status, day); /* eslint-disable-next-line */ }, [status, day]);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(status, day); } finally { setUnlocking(false); }
  }

  async function doGen() {
    setBusy(true); setMsg('Đang gom từ khoá đang lên thành ngách… (~1 phút)');
    try {
      const r = await genNiches({ max: 8 });
      setMsg('✓ ' + r.message);
      setStatus('all');          // ngách vừa sinh có thể trùng tên cũ đã dùng -> xem hết cho khỏi hụt
      await load('all', day);
    } catch (e) {
      setMsg('Lỗi: ' + (e.response?.data?.message || e.message));
    } finally { setBusy(false); }
  }

  async function setSt(id, st) {
    try { await updateNiche(id, { status: st }); await load(status, day); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
  }
  async function del(id, name) {
    if (!window.confirm(`Xoá ngách "${name}"?`)) return;
    try { await removeNiche(id); await load(status, day); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
  }
  function copyBrief(n) {
    const txt = [
      `NICHE: ${n.name}`,
      `Audience: ${n.audience}`,
      `Occasion: ${n.occasion}`,
      `Angle: ${n.angle}`,
      `Quote: ${n.quote}`,
      `Products: ${(n.products || []).join(', ')}`,
      `Keywords: ${(n.keywords || []).join(', ')}`,
    ].join('\n');
    navigator.clipboard?.writeText(txt);
    setMsg('✓ Đã chép đề bài ngách — dán vào chỗ làm thiết kế.');
  }

  if (!unlocked) {
    return (
      <div className="nc-root"><style>{CSS}</style>
        <div className="nc-lock"><div className="nc-lockCard">
          <div className="nc-lockIco">🦁</div><h2>Ngách</h2>
          <p className="nc-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="nc-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="nc-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="nc-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  const rows = data?.rows || [];
  const days = data?.days || [];

  return (
    <div className="nc-root"><style>{CSS}</style>
      <div className="nc-head">
        <div>
          <h2>Ngách</h2>
          <div className="nc-sub">{msg || 'Gom cụm từ khoá đang lên thành đề bài cụ thể: ai mua · mua dịp gì · câu chữ in lên sản phẩm.'}</div>
        </div>
        <div className="nc-sp" />
        <button className="nc-btn primary" onClick={doGen} disabled={busy}>
          {busy ? '⏳ Đang gom…' : '✨ Sinh ngách từ trend mới nhất'}</button>
      </div>

      <div className="nc-filters">
        {STATUS.map((s) => (
          <button key={s.key} className={'nc-pill' + (status === s.key ? ' on' : '')} onClick={() => setStatus(s.key)}>{s.label}</button>
        ))}
        {days.length > 0 && (
          <select className="nc-sel" value={day} onChange={(e) => setDay(e.target.value)}>
            <option value="">Mọi ngày</option>
            {days.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        )}
        <span className="nc-count">{data?.total ?? 0} ngách</span>
      </div>

      {rows.length === 0 ? (
        <div className="nc-empty">
          <div style={{ fontSize: 34, marginBottom: 8 }}>🧭</div>
          <b>Chưa có ngách nào ở mức này</b>
          <p>Bấm <b>✨ Sinh ngách từ trend mới nhất</b>. Cần có dữ liệu Ytrends trước (tab Ytrends hoặc Lịch mùa vụ).</p>
        </div>
      ) : (
        <div className="nc-grid">
          {rows.map((n) => {
            const comp = COMP[n.competition] || null;
            const isOpen = open === n.id;
            return (
              <div key={n.id} className={'nc-card' + (n.status === 'used' ? ' used' : '') + (n.status === 'skipped' ? ' skip' : '')}>
                <div className="nc-top">
                  {n.opportunity != null && <span className="nc-opp" title="Điểm cơ hội (gộp từ các từ khoá nguồn)">cơ hội {N(n.opportunity)}</span>}
                  {n.momentum != null && <span className="nc-mom" title="Đà tăng">đà {N(n.momentum)}</span>}
                  {comp && <span className={`nc-comp ${comp.c}`}>{comp.t}</span>}
                  <div className="nc-sp" />
                  {n.status === 'used' && <span className="nc-tag">đã dùng{n.usedCount > 1 ? ` ×${n.usedCount}` : ''}</span>}
                </div>

                <div className="nc-name">{n.name}</div>
                <div className="nc-quote">“{n.quote}”</div>

                <div className="nc-who">
                  <div><i>Ai mua</i> {n.audience}</div>
                  <div><i>Dịp</i> {n.occasion}</div>
                </div>

                {isOpen && (
                  <>
                    <div className="nc-angle">{n.angle}</div>
                    {n.desc && <div className="nc-desc">{n.desc}</div>}
                  </>
                )}

                <div className="nc-kws">
                  {(n.keywords || []).slice(0, isOpen ? 99 : 4).map((k) => <span key={k} className="nc-kw">{k}</span>)}
                  {!isOpen && (n.keywords || []).length > 4 && <span className="nc-kw more">+{n.keywords.length - 4}</span>}
                </div>
                <div className="nc-prods">{(n.products || []).join(' · ')}</div>

                <div className="nc-acts">
                  <button className="nc-btn sm" onClick={() => setOpen(isOpen ? null : n.id)}>{isOpen ? 'Thu gọn' : 'Chi tiết'}</button>
                  <button className="nc-btn sm" onClick={() => copyBrief(n)}>⧉ Chép đề bài</button>
                  <div className="nc-sp" />
                  {n.status !== 'used' && <button className="nc-btn sm" onClick={() => setSt(n.id, 'used')}>✓ Đã dùng</button>}
                  {n.status !== 'skipped' && <button className="nc-btn sm" onClick={() => setSt(n.id, 'skipped')}>Bỏ qua</button>}
                  {n.status !== 'new' && <button className="nc-btn sm" onClick={() => setSt(n.id, 'new')}>↺ Chưa dùng</button>}
                  <button className="nc-btn sm danger" onClick={() => del(n.id, n.name)}>Xoá</button>
                </div>
                <div className="nc-day">{n.day}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const CSS = `
.nc-root{color:var(--text)}
.nc-head{display:flex;align-items:flex-start;gap:12px;margin-bottom:14px}
.nc-head h2{margin:0 0 4px;font-size:20px}
.nc-sub{color:var(--muted);font-size:13px;max-width:720px}
.nc-sp{flex:1}
.nc-btn{border:1px solid var(--border);background:var(--panel);color:var(--text);padding:8px 14px;border-radius:9px;font-size:13px;font-weight:600;cursor:pointer}
.nc-btn:hover{border-color:var(--accent)}
.nc-btn:disabled{opacity:.55;cursor:not-allowed}
.nc-btn.primary{background:var(--accent);color:#fff;border-color:var(--accent)}
.nc-btn.sm{padding:5px 10px;font-size:12px;font-weight:500}
.nc-btn.sm.danger:hover{border-color:#e5484d;color:#e5484d}

.nc-filters{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:14px}
.nc-pill{border:1px solid var(--border);background:var(--panel);color:var(--muted);padding:5px 13px;border-radius:999px;font-size:12px;font-weight:600;cursor:pointer}
.nc-pill.on{background:var(--accent);color:#fff;border-color:var(--accent)}
.nc-sel{border:1px solid var(--border);background:var(--panel);color:var(--text);padding:5px 9px;border-radius:8px;font-size:12px}
.nc-count{color:var(--muted);font-size:12px;margin-left:auto}

.nc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(330px,1fr));gap:14px}
.nc-card{position:relative;border:1px solid var(--border);border-radius:14px;background:var(--panel);padding:14px 15px 12px}
.nc-card.used{opacity:.72}
.nc-card.skip{opacity:.45}
.nc-top{display:flex;align-items:center;gap:6px;margin-bottom:8px;flex-wrap:wrap}
.nc-opp,.nc-mom,.nc-comp,.nc-tag{font-size:11px;font-weight:700;padding:2px 8px;border-radius:999px;border:1px solid var(--border);color:var(--muted)}
.nc-opp{background:rgba(99,102,241,.13);color:#818cf8;border-color:transparent}
.nc-comp.ok{background:rgba(62,207,142,.14);color:#3ecf8e;border-color:transparent}
.nc-comp.mid{background:rgba(240,167,66,.14);color:#f0a742;border-color:transparent}
.nc-comp.hot{background:rgba(229,72,77,.14);color:#e5484d;border-color:transparent}

.nc-name{font-size:15px;font-weight:700;line-height:1.3;margin-bottom:5px}
.nc-quote{font-size:13px;font-style:italic;color:var(--accent);margin-bottom:10px}
.nc-who{font-size:12px;color:var(--muted);line-height:1.6;margin-bottom:8px}
.nc-who i{display:inline-block;min-width:52px;font-style:normal;opacity:.65}
.nc-angle{font-size:12.5px;line-height:1.55;margin-bottom:8px;padding:8px 10px;border-left:2px solid var(--accent);background:rgba(127,127,127,.06);border-radius:0 6px 6px 0}
.nc-desc{font-size:12px;color:var(--muted);line-height:1.5;margin-bottom:8px}

.nc-kws{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:7px}
.nc-kw{font-size:11px;padding:2px 7px;border-radius:5px;background:rgba(127,127,127,.11);color:var(--muted)}
.nc-kw.more{opacity:.6}
.nc-prods{font-size:11.5px;color:var(--muted);opacity:.8;margin-bottom:10px}
.nc-acts{display:flex;align-items:center;gap:6px;flex-wrap:wrap;border-top:1px solid var(--border);padding-top:9px}
.nc-day{position:absolute;top:14px;right:15px;font-size:10.5px;color:var(--muted);opacity:.5}

.nc-empty{border:1px dashed var(--border);border-radius:14px;padding:40px 20px;text-align:center;color:var(--muted)}
.nc-empty p{font-size:13px;margin:6px 0 0}

.nc-lock{display:flex;justify-content:center;padding:60px 20px}
.nc-lockCard{width:340px;text-align:center;border:1px solid var(--border);border-radius:16px;background:var(--panel);padding:28px 24px}
.nc-lockIco{font-size:34px;margin-bottom:6px}
.nc-lockCard h2{margin:0 0 6px;font-size:19px}
.nc-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.nc-lockInput{width:100%;border:1px solid var(--border);background:var(--bg,transparent);color:var(--text);padding:9px 12px;border-radius:9px;font-size:14px}
.nc-lockErr{margin-top:12px;color:#e5484d;font-size:12.5px}
`;
